import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "react-apollo";
import {
  GetHistoryTasks as GetHistoryTasksGenerated,
  GetHistoryTasksVariables as GetHistoryTasksVariablesGenerated,
  GetHistoryTasks_createdTaskConnections_tasks as HistoryTaskDataGenerated,
} from "core/queries/__generated__/GetHistoryTasks";

// Queries
export interface HistoryTaskData extends HistoryTaskDataGenerated {}
export interface GetHistoryTasksResponse extends GetHistoryTasksGenerated {}
export interface GetHistoryTasksVariables
  extends GetHistoryTasksVariablesGenerated {}

export const historyTaskFragment = gql`
  fragment HistoryTaskFragment on Task {
    id
    assignee {
      id
      firstName
      lastName
      email
    }
    building {
      id
      shortInternalRef
    }
    completedAt
    createdAt
    cufSpace {
      id
      internalRef
    }
    dueAt
    duringStay
    name
    priority
    unit {
      id
      shortInternalRef
    }
    subjectType
    status
    type
  }
`;

export const getHistoryTasks = gql`
  query GetHistoryTasks(
    $limit: Int
    $cursor: String = "0"
    $completedFilter: TaskFilterInput
    $createdFilter: TaskFilterInput
    $sort: [TaskSortInput!]
  ) {
    createdTaskConnections: taskConnections(
      limit: $limit
      cursor: $cursor
      filter: $createdFilter
      sort: $sort
    ) {
      total
      cursor
      hasMore
      tasks {
        id
        ...HistoryTaskFragment
      }
    }
    completedTaskConnections: taskConnections(
      limit: $limit
      cursor: $cursor
      filter: $completedFilter
      sort: $sort
    ) {
      total
      cursor
      hasMore
      tasks {
        id
        ...HistoryTaskFragment
      }
    }
  }
  ${historyTaskFragment}
`;

export const getHistoryTasksQuery = (
  options: QueryHookOptions<GetHistoryTasksResponse, GetHistoryTasksVariables>,
) => {
  return useQuery<GetHistoryTasksResponse, GetHistoryTasksVariables>(
    getHistoryTasks,
    {
      ...options,
    },
  );
};
